import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setConnectionStatus, setDarkMode } from './Redux/store';
import './App.css';
import './Pages/Calendar/CalendarBottomMenu2.css';
import TopBar from './Nav/TopBar';
import PageDisplay from './Pages/PageDisplay';
import BottomNav from './Nav/BottomNav';
import RaisedBottomNav from './Nav/RaisedBottomNav';
import Menus from './Menus/Menus';
import Loaders from './Loaders/Loaders';
import LoadingIndicator from './components/LoadingIndicator';
import ImageTest from './components/ImageTest';
import { AuthGate } from './Pages/Auth/AuthGate';
import useUploadsPersistence from './hooks/useUploadsPersistence';

function App() {
  const dispatch = useDispatch();

  // Persist uploads to localStorage
  useUploadsPersistence();

  // Initialize dark mode from localStorage on app mount
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode');
    if (savedDarkMode !== null) {
      const isDark = savedDarkMode === 'true';
      dispatch(setDarkMode(isDark));
      if (isDark) {
        document.documentElement.classList.add('dark');
      }
    }
  }, [dispatch]);

  // Sync browser online/offline status to Redux
  useEffect(() => {
    const updateStatus = () => {
      dispatch(setConnectionStatus(navigator.onLine ? 'online' : 'offline'));
    };

    // Initial check
    updateStatus();

    // Listen for online/offline events
    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    };
  }, [dispatch]);

  return (
    <AuthGate>
      <div className="relative flex h-[100dvh] w-full flex-col overflow-hidden bg-background text-foreground">
        <TopBar />
        <PageDisplay />
        <BottomNav />
        <Menus />
        <Loaders />
        <LoadingIndicator />
        {/* <RaisedBottomNav /> */}
        
        {/* Test square - for testing image migration */}
        {/* <ImageTest /> */}
      </div>
    </AuthGate>
  );
}

export default App;
